<template>
  CMS 자동이체  
</template>
<script setup lang="ts">
import { ref, onMounted } from 'vue';
import axios from 'axios';
const cmsMemberList = ref([]);
const getCmsMemberList = async () => {
  try {
    const response = await axios.get('/api/cms/getCmsMemberList');
    if (response.data.success) {
      cmsMemberList.value = response.data.data;
    } else {
      console.error('CMS 목록 가져오기 중 에러 발생:', response.data.message);
    }
  } catch (error) {
    console.error('CMS 목록 가져오기 중 에러 발생:', error);
    throw error;
  }
}
onMounted(() => {
  getCmsMemberList();
});
</script>